import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const FilterIcon = (props: IconProps) => (
  <Icon height="16px" width="16px" viewBox="0 0 16 16" {...props}>
    <path d="M6.667 12h2.666v-1.333H6.667V12ZM2 4v1.333h12V4H2Zm2 4.667h8V7.333H4v1.334Z" />
  </Icon>
);

export default memo(FilterIcon);
